import React from 'react'
import { RenderCurrency, RenderDollar } from '../../../Utils/renderField/renderReadField'

/**
 * Componente que muestra un resumen de las bonificaciones totales.
 * @param {Object} props - Props del componente.
 * @param {number} props.total_bonif_nh3 - Total de bonificación por NH3.
 * @param {number} props.total_bonif_fletes - Total de bonificación por fletes.
 * @param {number} props.total_bonificaciones - Total de bonificaciones.
 * @param {number} props.total_dolares - Total en dólares.
 * @param {number} props.total_quetzales - Total en quetzales.
 * @param {number} props.cambio_dolar - Tasa de cambio de dólares a quetzales.
 * @returns {JSX.Element} - Componente de resumen de bonificaciones totales.
 */
const TotalesBonificacion = (props) => {
    const {
        total_bonif_nh3,
        total_bonif_fletes,
        total_bonificaciones,
        total_dolares,
        total_quetzales,
        cambio_dolar,
        aplica_bonif_amoniaco,
        aplica_bonif_fletes,
    } = props;
    console.log('amoniaco nh3', total_bonif_nh3);
    // const total_con_bonificaciones = total_dolares + total_bonificaciones;
    // const total_con_bonificaciones_quetzales = total_quetzales + (total_bonificaciones * cambio_dolar);

    return (
        <div>
            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-4 mb-1">
                <div className="new-table-wrapper liquidaciones-crear__table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th colSpan={3}>BONIFICACIONES</th>
                            </tr>
                            <tr>
                                <th>CONCEPTO BONIFICACIÓN</th>
                                <th>BONIFICACIÓN ($)</th>
                                <th>BONIFICACIÓN (Q)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {aplica_bonif_amoniaco && (
                                <tr>
                                    <td className='text-center font-weight-bold'>Uso de Amoniaco</td>
                                    <td className='td--right'><RenderDollar value={total_bonif_nh3} decimalScale={4} /></td>
                                    <td className='td--right'><RenderCurrency value={total_bonif_nh3 * cambio_dolar} decimalScale={4} /></td>
                                </tr>
                            )}
                            {aplica_bonif_fletes && (
                                <tr>
                                    <td className='text-center font-weight-bold'>Eficiencia de Flete</td>
                                    <td className='td--right'><RenderDollar value={total_bonif_fletes} decimalScale={4} /></td>
                                    <td className='td--right'><RenderCurrency value={total_bonif_fletes * cambio_dolar} decimalScale={4} /></td>
                                </tr>
                            )}
                            <tr className='liquidaciones-crear__fila-total'>
                                <td className='text-center font-weight-bold'>TOTAL</td>
                                <td className='td--right'><RenderDollar value={total_bonificaciones} decimalScale={4} /></td>
                                <td className='td--right'><RenderCurrency value={total_bonificaciones * cambio_dolar} decimalScale={4} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-3 mb-3">
                <div className="new-table-wrapper liquidaciones-crear__table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th colSpan={2}>TOTAL + BONIFICACIONES</th>
                            </tr>
                            <tr>
                                <th>TOTAL DÓLARES</th>
                                <th>TOTAL QUETZALES</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='liquidaciones-crear__fila-total'>
                                <td className='text-center font-weight-bold'><RenderDollar value={total_dolares} decimalScale={4} /></td>
                                <td className='text-center font-weight-bold'><RenderCurrency value={total_quetzales} decimalScale={4} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default TotalesBonificacion;
